var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28549 6.69999H18.7141C19.1962 6.69999 19.5712 6.32086 19.5712 5.8333V4.09999C19.5712 2.69166 18.3926 1.5 16.9998 1.5H10.9998C9.60693 1.5 8.42836 2.69166 8.42836 4.09999V5.8333C8.42836 6.32086 8.80335 6.69999 9.28549 6.69999Z",
    fill: "#222939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4286 3.66665H22.5714C22.3036 3.66665 22.1429 3.82917 22.1429 4.09999V5.8333C22.1429 7.72913 20.5893 9.29998 18.7143 9.29998H9.28572C7.41072 9.29998 5.85714 7.72913 5.85714 5.8333V4.09999C5.85714 3.82917 5.69643 3.66665 5.42858 3.66665H4.57142C3.17857 3.66665 2 4.85831 2 6.26665V24.8999C2 26.3083 3.17857 27.5 4.57142 27.5H23.4286C24.8214 27.5 26 26.3083 26 24.8999V6.26665C26 4.85831 24.8214 3.66665 23.4286 3.66665Z",
    fill: "#222939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12.5L9.27665 17.7234C8.77937 18.2206 8.5 18.8951 8.5 19.5984V19.6594C8.5 21.0901 9.65986 22.25 11.0906 22.25C11.6021 22.25 12.1021 22.0986 12.5276 21.8149L13.8438 20.9375L13 23.75V24.5H16V23.75L15.1562 20.9375L16.4724 21.8149C16.8979 22.0986 17.3979 22.25 17.9094 22.25C19.3401 22.25 20.5 21.0901 20.5 19.6594V19.5984C20.5 18.8951 20.2206 18.2206 19.7234 17.7234L14.5 12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory3);
export default __webpack_public_path__ + "static/media/history-3.e96f9a314b76d4e33ede4f03d1f49aa6.svg";
export { ForwardRef as ReactComponent };